import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { HelperService } from 'app/core/feature/helper/helper.service';
import {
  BasicFieldData,
  InputField,
} from 'app/core/model/common/input-field.model';

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputNumberComponent {
  @Input() fieldOption: InputField = new InputField();
  @Input() pk: string = '';
  @Output() fieldChange = new EventEmitter<InputField>(); // Output event
  @Output() enableEditField = new EventEmitter<string>();
  @Output() saveEnabledField = new EventEmitter<string>();
  valueOfData: any;
  requiredError: boolean = false;
  requiredMin: boolean = false;
  requiredMax: boolean = false;
  constructor(private helperService: HelperService) {}

  ngOnInit() {
    this.fieldOption.pk = this.pk
    this.valueOfData = this.fieldOption.value;
    if(this.valueOfData){
      this.onInputChange()
    }
    if (!this.fieldOption.valid) {
      this.fieldChange.emit(this.fieldOption);
    }
  }

  onInputChange() {
    let valid = true;
    this.fieldOption.value = this.valueOfData;
    const { validator, value } = this.fieldOption;
    if (validator) {
      if (validator[0].required && !this.helperService.isNotEmpty(value)) {
        valid = false;
        this.requiredError = true;
      } else {
        this.requiredError = false;
      }
      if (
        !this.requiredError &&
        validator[0].min &&
        !this.helperService.hasMinLength(value.toString(), validator[0].min)
      ) {
        valid = false;
        this.requiredMin = true;
      } else {
        this.requiredMin = false;
      }
      if (
        !this.requiredError &&
        validator[0].max &&
        !this.helperService.hasMaxLength(value.toString(), validator[0].max)
      ) {
        valid = false;
        this.requiredMax = true;
      } else {
        this.requiredMax = false;
      }
    }
    this.fieldOption.valid = valid;
    this.fieldChange.emit(this.fieldOption);
  }

  onEdit(controlName: string){
    this.enableEditField.emit(controlName);
  }

  onSave(controlName: string){
    this.saveEnabledField.emit(controlName);
  }
}
